"use client"

import { ConstructionIcon } from "lucide-react"

import { useTranslations } from "@/i18n"
import { EmptyState } from "@ibada/ui"

type ComingSoonProps = {
  /** Optional explicit title; falls back to the shared `comingSoon.title` string. */
  title?: string
  /** Optional explicit description; falls back to the shared `comingSoon.description` string. */
  description?: string
}

/**
 * Consistent "Coming Soon" placeholder for navigation entries whose feature is not built yet. Reuses the shared
 * `EmptyState` so every not-yet-implemented page reads identically across the app (mirrors the department
 * coming-soon pattern). Used by the Parish navigation foundation for Budgets, Audit Log, Accounts, Remittances,
 * the branch-details tabs blocked by cross-branch authorization, etc.
 */
export function ComingSoon({ title, description }: ComingSoonProps) {
  const t = useTranslations("comingSoon")
  return (
    <EmptyState
      icon={<ConstructionIcon className='size-8' strokeWidth={1.5} />}
      title={title ?? t("title")}
      description={description ?? t("description")}
    />
  )
}
